import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CacBaseDialogComponent, CacButtonComponent, ButtonClickEvent, CacFormBuilderComponent, formBuilder } from '@controladad/ng-base';
import { formControl } from '@al00x/forms';

export interface InvoiceDateDialogData {
  message?: string;
  invoiceDate?: Date | null;
}

export type InvoiceDateDialogResult = { overrideDate: Date | null } | null;

@Component({
  selector: 'lib-invoice-date-dialog',
  standalone: true,
  imports: [CommonModule, CacButtonComponent, CacFormBuilderComponent],
  templateUrl: './invoice-date-dialog.component.html',
  styleUrl: './invoice-date-dialog.component.scss',
})
export class InvoiceDateDialogComponent extends CacBaseDialogComponent<
  InvoiceDateDialogData,
  InvoiceDateDialogResult
> {
  form = formBuilder({
    cols: 1,
    inputs: {
      invoiceDate: {
        control: formControl<Date | null>(this.data?.invoiceDate ?? new Date()),
        label: 'Invoice Date',
        type: 'datetime',
      },
    },
  });

  getMessage(): string {
    return this.data?.message || 'Would you like to override the invoice date?';
  }

  onDownload(e: ButtonClickEvent) {
    const value = this.form.getValue();
    e.setLoading(false);
    this.submit({ overrideDate: value?.invoiceDate || null });
  }

  onCancel(e: ButtonClickEvent) {
    e.setLoading(false);
    this.submit(null);
  }
}
